module.exports = __webpack_public_path__ + "static/media/Zoe-Zimmer-Mixed-Media-Photography.3a325716.jpg";